/**
 * Stable CSS class names for E2E — Email & SMS service logs (filters, grids).
 */
export const EASL = {
    page: 'email-and-sms-service-logs-page',
    headerWrap: 'email-and-sms-service-logs-page__header-wrap',
    alertWrap: 'email-and-sms-service-logs-page__alert-wrap',
    filtersRow: 'email-and-sms-service-logs-page__filters-row',
    dateRangeWrap: 'email-and-sms-service-logs-page__date-range-wrap',
    searchCompositeWrap: 'email-and-sms-service-logs-page__search-composite-wrap',
    smsToolbarSlot: 'email-and-sms-service-logs-page__sms-toolbar-slot',
    emptyStateWrap: 'email-and-sms-service-logs-page__empty-state-wrap',
    smsGridWrap: 'email-and-sms-service-logs-page__sms-grid-wrap',
    mailGridWrap: 'email-and-sms-service-logs-page__mail-grid-wrap',
} as const;

export const easlCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
